export default "__VITE_ASSET__1161fe6c__"